module.exports = __webpack_public_path__ + "static/media/spinner.858830ed.svg";